<div *ngIf="!isLoading; else spinner">
  <mat-dialog-content>
    <h1 id="heading">Edit Camping On Field</h1>
    <div class="container">
      <div class="edit-camping__section-content">
        <mat-checkbox *ngIf="CampingOnFieldTag" #checkbox [checked]="isChecked(CampingOnFieldTag.tagId)" [id]="CampingOnFieldTag.tagId"
                      (change)="checkBoxChanged($event)">Camping On Field</mat-checkbox><br />
      </div>
      <fieldset class="edit-camping__section" [disabled]="!isChecked(CampingOnFieldTag.tagId)">
        <legend>Availability</legend>
        <div class="edit-camping__section-content">
          <!-- <mat-checkbox *ngIf="CampingOnFieldTag" #checkbox [checked]="isChecked(CampingOnFieldTag.tagId)" [id]="CampingOnFieldTag.tagId"
                        (change)="checkBoxChanged($event)">Camping On Field</mat-checkbox><br /> -->
          <mat-radio-group [(ngModel)]="chosenAvailability" (change)="availabilityChanged()"
                           class="edit-camping__radio-group" required #radioGroup="matRadioGroup" [disabled]="!isChecked(CampingOnFieldTag.tagId)">
            <mat-radio-button class="edit-camping__radio-button" value="Year-Round">Year-Round</mat-radio-button><br>
            <mat-radio-button class="edit-camping__radio-button" value="Seasonal">Seasonal</mat-radio-button><br>
            <mat-radio-button class="edit-camping__radio-button" value="Special Events Only">Special Events Only</mat-radio-button><br>
          </mat-radio-group>
          <mat-checkbox class="edit-camping__reservations-checkbox" *ngIf="ReservationsTag" #checkbox [checked]="isChecked(ReservationsTag.tagId)" [id]="ReservationsTag.tagId"
                        (change)="checkBoxChanged($event)" [disabled]="!isChecked(CampingOnFieldTag.tagId)">Reservation Required</mat-checkbox>
        </div>
      </fieldset>
      <fieldset class="edit-camping__section">
        <legend>Facilities</legend>
        <div class="edit-camping__section-content">
          <mat-checkbox *ngIf="FoodTag" #checkbox [checked]="isChecked(FoodTag.tagId)" [id]="FoodTag.tagId"
                        (change)="checkBoxChanged($event)" [disabled]="!isChecked(CampingOnFieldTag.tagId)">Food/Vending</mat-checkbox><br>
          <mat-checkbox *ngIf="PotableWaterTag" #checkbox [checked]="isChecked(PotableWaterTag.tagId)" [id]="PotableWaterTag.tagId"
                        (change)="checkBoxChanged($event)" [disabled]="!isChecked(CampingOnFieldTag.tagId)">Potable Water</mat-checkbox><br>
          <mat-checkbox *ngIf="RestroomsTag" #checkbox [checked]="isChecked(RestroomsTag.tagId)" [id]="RestroomsTag.tagId"
                        (change)="checkBoxChanged($event)" [disabled]="!isChecked(CampingOnFieldTag.tagId)">Restrooms</mat-checkbox><br>
          <mat-checkbox *ngIf="ShelterTag" #checkbox [checked]="isChecked(ShelterTag.tagId)" [id]="ShelterTag.tagId"
                        (change)="checkBoxChanged($event)" [disabled]="!isChecked(CampingOnFieldTag.tagId)">Shelter</mat-checkbox><br>
          <mat-checkbox *ngIf="ShowersTag" #checkbox [checked]="isChecked(ShowersTag.tagId)" [id]="ShowersTag.tagId"
                        (change)="checkBoxChanged($event)" [disabled]="!isChecked(CampingOnFieldTag.tagId)">Showers</mat-checkbox>
        </div>
      </fieldset>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button [disabled]="disableClose" class="mat-raised-button" (click)="close()">Close</button>
  </mat-dialog-actions>
</div>
<ng-template #spinner>
  <div class="spinnerContainer">
    <mat-spinner  class="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </div>
</ng-template>
